import Header from 'features/shared/layout/header/Header';
import React from 'react'
import { useTranslation } from 'react-i18next';
import RolesChecker from 'features/customer/components/RolesChecker';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import PhoneFormSection from 'features/requirements/sections/requirementFormTypes/phoneForm/PhoneFormSection';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { isEnabledCustomForm } from 'features/requirements/helpers/requirementTypeHelper';

type Props = {}

const ChangePhonePage = (props: Props) => {
  // translations
  const { t } = useTranslation("shared\\moduleNames");
  const tLabels = useTranslation("customer\\customer").t;

  return (
    <RenderWrapper isVisible={() => isEnabledCustomForm("ZMENATELEFONU")}>
      <RolesChecker enabledRoles="Contributor">
        <Header title={t("changePhonePage.title")} 
          includeBreadcrumbs
          links={[
            { text: t("customer.title"), to: "/customer" }
          ]} 
        />
        <ModuleContent>
          <PhoneFormSection 
            useOutsideOfRequirements  
            sendButtonTitle={tLabels("changePhonePage.changePhone")} 
          />
        </ModuleContent>
      </RolesChecker>
    </RenderWrapper>
  )
}

export default ChangePhonePage;